import MasterCrudPage from "../../components/MasterCrudPage";
import {
  orderMasterApi,
  reviewRatingApi,
  serviceApi,
  userMasterApi,
  userRoleApi,
} from "../../api/masterApi";
import {
  filterBuyerUsers,
  filterSellerUsers,
  userDisplayName,
} from "../../utils/userRoleFilters";

export default function ReviewRating() {
  return (
    <MasterCrudPage
      title="Review & Rating"
      description="Manage buyer reviews and ratings for orders and assets."
      idKey="review_id"
      api={reviewRatingApi}
      listLabel="reviews & ratings"
      useJson
      loadExtraOptions={async () => {
        const [orders, users, roles, assets] = await Promise.all([
          orderMasterApi.list(),
          userMasterApi.list(),
          userRoleApi.list(),
          serviceApi.list(),
        ]);

        const buyers = filterBuyerUsers(users, roles);
        const sellers = filterSellerUsers(users, roles);

        return {
          orders: (orders || []).map((order) => ({
            value: order.order_id,
            label: `Order #${order.order_id}`,
          })),
          buyers: buyers.map((user) => ({
            value: user.user_id,
            label: userDisplayName(user),
          })),
          sellers: sellers.map((user) => ({
            value: user.user_id,
            label: userDisplayName(user),
          })),
          assets: (assets || []).map((asset) => ({
            value: asset.service_id,
            label: asset.service_title || "Asset",
          })),
        };
      }}
      fields={[
        {
          name: "order_id",
          label: "Order",
          type: "select",
          required: true,
          optionsKey: "orders",
          placeholder: "Select order",
        },
        {
          name: "buyer_id",
          label: "Buyer",
          type: "select",
          required: true,
          optionsKey: "buyers",
          placeholder: "Select buyer",
        },
        {
          name: "seller_id",
          label: "Seller",
          type: "select",
          required: true,
          optionsKey: "sellers",
          placeholder: "Select seller",
        },
        {
          name: "asset_id",
          label: "Asset",
          type: "select",
          required: true,
          optionsKey: "assets",
          placeholder: "Select asset",
        },
        {
          name: "rating",
          label: "Rating",
          type: "number",
          required: true,
          min: "0",
          max: "5",
          step: "0.1",
          placeholder: "e.g. 4.5",
        },
        {
          name: "review_date",
          label: "Date",
          type: "datetime-local",
        },
        {
          name: "review",
          label: "Review",
          type: "textarea",
          fullWidth: true,
          placeholder: "Enter review",
        },
      ]}
      columns={[
        { key: "review_id", label: "Review ID" },
        {
          key: "order_id",
          label: "Order ID",
          render: (item) => (item.order_id != null ? `#${item.order_id}` : "—"),
        },
        {
          key: "buyer_id",
          label: "Buyer",
          render: (item) =>
            [item.buyer_first_name, item.buyer_last_name]
              .filter(Boolean)
              .join(" ") || "—",
        },
        {
          key: "seller_id",
          label: "Seller",
          render: (item) =>
            [item.seller_first_name, item.seller_last_name]
              .filter(Boolean)
              .join(" ") || "—",
        },
        {
          key: "asset_id",
          label: "Asset",
          render: (item) => item.service_title || "—",
        },
        { key: "rating", label: "Rating" },
        { key: "review", label: "Review" },
        {
          key: "review_date",
          label: "Date",
          render: (item) =>
            item.review_date
              ? String(item.review_date).replace("T", " ").slice(0, 19)
              : "—",
        },
      ]}
    />
  );
}
